module.exports = __webpack_public_path__ + "static/img/p3_t3.7875cf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/p3_t3.png
// module id = yiMu
// module chunks = 0